import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";

const TARGET_URL = "https://sncksncdqeus2devas.azurewebsites.net/feature-requests";

const FeatureRedirect = () => {
  const [countdown, setCountdown] = useState(3);
  const [redirected, setRedirected] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (countdown === 0 && !redirected) {
      window.open(TARGET_URL, "_blank", "noopener,noreferrer");
      setRedirected(true);
    }
  }, [countdown, redirected]);

  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        textAlign: "center",
        px: 2,
      }}
    >
      <Typography variant="h4" fontWeight={600} color="#FF03F3">
        Redirecting to Staging Feature Requests
      </Typography>
      <Typography variant="body1" color="text.secondary" maxWidth="600px">
        You are being redirected to the live Feature Requests experience. The page
        will open in a new tab automatically. If it doesn't, use the button below.
      </Typography>
      <Box display="flex" alignItems="center" gap={2}>
        {!redirected && <CircularProgress thickness={5} sx={{ color: "#FF03F3" }} />}
        <Typography variant="h6" fontWeight={600}>
          {redirected ? "Redirected. Please check the new tab." : `Redirecting in ${countdown}...`}
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary">
        If the new tab doesn't open automatically, please allow pop-ups for this
        site and refresh the page.
      </Typography>
    </Box>
  );
};

export default FeatureRedirect;

